module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.dataForm), function(data, index) {
    return [(data.dataType === 'input') ? _c('simple-input', {
      key: 'input-' + index,
      attrs: {
        "data": data,
        "validation": _vm.validation,
        "disabled": _vm.disabled
      }
    }) : _vm._e(), _vm._v(" "), (data.dataType === 'input-double') ? _c('double-input', {
      key: 'input-' + index,
      attrs: {
        "data": data,
        "validation": _vm.validation,
        "disabled": _vm.disabled
      }
    }) : _vm._e(), _vm._v(" "), (data.dataType === 'select') ? _c('select-input', {
      key: 'select-' + index,
      attrs: {
        "data": data,
        "locations": _vm.locations,
        "banks": _vm.banks,
        "bankAccountTypes": _vm.bankAccountTypes,
        "validation": _vm.validation,
        "disabled": _vm.disabled
      }
    }) : _vm._e(), _vm._v(" "), (data.dataType === 'upload') ? _c('el-row', {
      key: 'upload-' + index
    }, [_c('el-col', {
      staticStyle: {
        "marginbottom": "25px"
      },
      attrs: {
        "span": 8
      }
    }, [_c('pdf-file', {
      attrs: {
        "pdfFilePath": data.model,
        "habModificaPdf": _vm.habModificaPdf,
        "titulo": data.label,
        "id": data.label,
        "prop": data.name,
        "country": 'PER',
        "disabled": _vm.disabled
      },
      on: {
        "update:pdfFilePath": function($event) {
          return _vm.$set(data, "model", $event)
        },
        "update:pdf-file-path": function($event) {
          return _vm.$set(data, "model", $event)
        }
      }
    })], 1), _vm._v(" "), (_vm.verifyFields(data, _vm.validation)) ? _c('el-alert', {
      staticClass: "message-warning",
      attrs: {
        "title": ("Falta completar: " + (data.label)),
        "type": "error",
        "closable": false
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (data.dataType === 'switch-perception') ? _c('switch-perception', {
      key: 'switch-perception' + index,
      attrs: {
        "data": data,
        "validation": _vm.validation,
        "disabled": _vm.disabled
      }
    }) : _vm._e(), _vm._v(" "), (data.dataType === 'switch-retention') ? _c('switch-retention', {
      key: 'switch-retention' + index,
      attrs: {
        "data": data,
        "denominaciones": _vm.denominaciones,
        "validation": _vm.validation,
        "disabled": _vm.disabled
      }
    }) : _vm._e(), _vm._v(" "), (data.dataType === 'switch-detraction') ? _c('switch-detraction', {
      key: 'switch-detraction' + index,
      attrs: {
        "data": data,
        "validation": _vm.validation,
        "disabled": _vm.disabled
      }
    }) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5edcad1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/AltaFormElements.vue
// module id = 636
// module chunks = 1